import { search } from "../BaseRepositoryComponents";

const baseUrl = process.env.REACT_APP_NEW_PAINEL_API_URL;

export function getEntityInstances(document) {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}`,
    method: "GET",
  });
}

export function addNewInstance(document) {
  return search({
    path: `${baseUrl}/v1/conectazap/instances`,
    method: "POST",
    myBody: {
      company_document: document,
    },
  });
}

export function getQrCode(document, instanceId) {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/qrcode/${instanceId}`,
    method: "GET",
    showMessage: false,
  });
  // return "vaitomanocu";
}

export function disconnectPhoneFromInstance(document, instanceId) {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/disconnect/${instanceId}`,
    method: "GET",
  });
}

export function updatePhoneUsage(document, phoneNumberId, typeUsage, value) {
  let body = {
    type_usage: typeUsage,
    value: value,
  };

  if (value) {
    body["phone_number_id"] = phoneNumberId;
  }
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/phone`,
    method: "PUT",
    myBody: body,
  });
}

export const deleteInstance = (document, instanceId) => {
  return search({
    path: `${baseUrl}/v1/conectazap/instances`,
    method: "DELETE",
    myBody: {
      company_document: document,
      instance_id: instanceId,
    },
  });
};
